export abstract class BitFormControlAbstraction {
  disabled: boolean;
  required: boolean;
  hasError: boolean;
  error: [string, any];
}
